import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";

function getHostname(url) {
  try {
    const { hostname } = new URL(url);
    return hostname;
  } catch (err) {
    // fallback for invalid URLs
    return null;
  }
}

const HANDOFF_COOKIE = 'cruzcontrolHandoff';

// Tenant apps keep their idle-timeout clock in their own subdomain's localStorage,
// which this origin cannot reach. Without a shared signal a stale clock from an
// earlier visit makes the tenant app log out a session the portal just created.
// Short expiry so it can never extend a tenant's idle window by more than a few minutes.
function stampHandoff() {
  Cookies.set(HANDOFF_COOKIE, new Date().toISOString(), {
    expires: 1 / 288, // 5 minutes
    domain: '.cruzcontrol.app',
    path: '/',
    secure: true,
    sameSite: 'lax'
  });
}

const initialState = () => ({
    cognitoUser: {
        email: null,
        accessToken: null
    },
    user: {
        id: null,
        email: null,
        firstname: null,
        lastname: null,
        active_tenant_id: null,
        accepted_agreement: null,
        accepted_timestamp: null,
        accepted_version: null,
        from_portal: true
    },
    currentRoute: null,
    theme: null
})


const userCookie = createPersistedState({
  key: 'cruzcontrol',
  paths:["user"],
  storage: {
    getItem: (key) => {
      return Cookies.get(key);
    },
    // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
    setItem: (key, value) =>
      Cookies.set(key, value, { expires: 365, domain: '.cruzcontrol.app', path: '/', secure: true, sameSite: true }),
    removeItem: key => Cookies.remove(key, { domain: '.cruzcontrol.app', path: '/' })
  }
})

const themeCookie = createPersistedState({
  key: 'cruzcontrolTheme',
  paths:["theme"],
  storage: {
    getItem: (key) => {
      return Cookies.get(key);
    },
    setItem: (key, value) =>
      Cookies.set(key, value, { expires: 365, domain: '.cruzcontrol.app', path: '/', secure: true, sameSite: true }),
    removeItem: key => Cookies.remove(key, { domain: '.cruzcontrol.app', path: '/' })
  }
})


export const store = createStore({
    plugins: [ userCookie, themeCookie ],
    state: initialState,
    getters: {
        getUser: (state) => state.user,
        getFullName: (state) => `${state.user.firstname} ${state.user.lastname}`,
        getEmail: (state) => state.user.email,
        getCurrentRoute: (state) => state.currentRoute,
        getLegalAcceptance: state => state.user.accepted_agreement,
        getTheme: state => state.theme
    },
    mutations: {
        async resetState (state) {
            const initial = initialState()
            const currentTheme = state.theme
            Object.keys(initial).forEach(key => { state[key] = initial[key] })
            state.theme = currentTheme
            Cookies.remove('cruzcontrol')
            Cookies.remove('cruzcontrolTheme')
            Cookies.remove(HANDOFF_COOKIE, { domain: '.cruzcontrol.app', path: '/' })
        },
        setTheme(state, theme) {
            state.theme = theme
            localStorage.setItem('cc-theme', theme)
        },
        async setCurrentRoute (state, newRoute) {
            state.currentRoute = newRoute
        },
        async setEmail(state, newEmail){
          state.user.email = newEmail;
        },
        async setUser(state, userData) {
            console.log(userData)
            state.user.id = userData.id;
            state.user.email = userData.email;
            state.user.firstname = userData.firstname;
            state.user.lastname = userData.lastname;
            state.user.accepted_agreement = userData.accepted_agreement;
            state.user.accepted_timestamp = userData.accepted_timestamp;
            state.user.accepted_version = userData.accepted_version;
            state.user.from_portal = true;
            stampHandoff();
        },
        async setAccessToken(state, newToken) {
            console.log(newToken);
            state.cognitoUser.accessToken = newToken;
        },
        async setActiveTenantId(state, { newTenantID, newTenantURL }) {
            Cookies.set('active_site', null, { domain: getHostname(newTenantURL) });
            state.user.active_tenant_id = newTenantID;
        },
        setIsFromPortal(state) {
          state.user.from_portal = true;
        },
        stampSessionHandoff() {
          stampHandoff();
        }
    }
})
